<ng-template #menu>
  @if (only_one_folder_selected() && 'contentplatform:repository:Mutation/CreateUploadTicket' | isAllowed: 'contentplatform:folder:input.folder_id/' + folder().id:organization()) {
    <a class="cl-a-btn" (click)="openGenUploadLinkFromSelection();">
      Upload files
    </a>
  }
  @if (allowSubmitOnAllFolder()) {
    <a class="cl-a-btn" (click)="!addingFolder() && submitSelected()" [class.cl-a-spinner]="addingFolder()" [class.cl-a-disabled]="addingFolder()">
      Add folders to PO
    </a>
  }
  @if (onlyDeletableSelected() && 'contentplatform:repository:Mutation/MoveFile'|isAllowed: 'contentplatform:file:input.src/' + this.folder().id: organization()) {
    <a class="cl-a-btn" (click)="move()">
      Move files
    </a>
  }
  @if (onlyDeletableSelected() && 'contentplatform:repository:Mutation/Delete'| isAllowed:  'contentplatform:file:input.id/' + this.folder().id: organization()) {
    <a class="cl-a-btn" (click)="onClickDelete()">
      Delete files
    </a>
  }
  @if (only_deleted_files_selected() && 'contentplatform:repository:Mutation/Undelete'| isAllowed:  'contentplatform:file:input.file_id/' + this.folder().id:organization()) {
    <a class="cl-a-btn" (click)="onClickUndelete()">
      Restore files
    </a>
  }
  @if (only_archived_files_selected() && 'contentplatform:repository:Mutation/Restore'| isAllowed: 'contentplatform:file:input.files/' + this.folder().id: organization()) {
    <a class="cl-a-btn" (click)="restore()">
      Unarchive files
    </a>
  }
  <a class="cl-a-btn" [class.cl-a-spinner]="copyid_feedback()" [class.cl-a-disabled]="copyid_feedback()" (click)="!copyid_feedback() && copyid()">
    Copy S3 Link
  </a>
  @if (only_one_nonarchived_file_selected() && 'contentplatform:repository:Mutation/MoveFile'| isAllowed: 'contentplatform:file:input.src/' + this.folder().id: organization()) {
    <a class="cl-a-btn" (click)="rename()">
      Rename file
    </a>
  }
  @if (allowCreateWorkspaceOnSelection()) {
    <a class="cl-a-btn"
       (click)="createEditingWorkspace()">
      Create Editing Workspace
    </a>
  }
</ng-template>

<section class="cl-section">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <p class="alert cl-alert-action">
          <a role="button" [class.cl-a-spinner]="refreshing()" [class.cl-a-disabled]="refreshing()" (click)="!refreshing() && refreshWithFeedback()">
            Refresh Listing
          </a>
          @if ('contentplatform:repository:Mutation/Mkdir' | isAllowed: 'contentplatform:folder:input.folder_id/' + folder().id: organization()) {
            <a role="button"
               (click)="mkdir(); ">
              Create Folder
            </a>
          }
          @if ('contentplatform:repository:Mutation/CreateUploadTicket' | isAllowed: 'contentplatform:folder:input.folder_id/' + folder().id: organization()) {
            <a role="button"
               (click)="openGenUploadLink();">
              Upload Files
            </a>
          }

          <a role="button" (click)="viewAsAsset()">View as Asset</a>

          <app-s3-link style="margin-left: 16px" [fof]="this.folder()"></app-s3-link>
        </p>
      </div>
    </div>
  </div>

</section>
<app-filter-section [all]="items()"
                    [filtered]="items_sorted_and_filtered()"
                    [formGroup]="filters">
  <form [formGroup]="filters" class="cl-form">
    <input type="text" style="width: 100%" formControlName="t"
           placeholder="Filter by name" autofocus>
    <p class="valid-feedback">Filters are case-insensitive.</p>
    <div class="form-check cl-spacing-tiny">
      <input class="form-check-input" type="checkbox" formControlName="d"
             id="check1">
      <label class="form-check-label" for="check1">Hide deleted files</label>
    </div>
  </form>
</app-filter-section>
<section class="cl-section cl-form">

  <div class="container">
    <div class="row">
      @if (items_sorted_and_filtered(); as items) {
        <div class="col-12">
          <table style="table-layout: fixed" class="cl-table-data">
            <colgroup>
              <col span="1" style="width: 40px">
              <col span="1" style="width: 40px">
              <col span="1" style="width: 100%">
              @if (!isSmall()) {
                <col span="1" style="width: 170px;">
              }
              @if (!isSmall()) {
                <col span="1" style="width: 100px;">
              }
            </colgroup>
            <thead>
            <tr>
              <th class="cl-table-head ">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" [checked]="checked()"
                         [indeterminate]="indeterminate()"
                         (change)="toggleAll()"/>
                </div>
              </th>
              <th class="" style="margin-top: -4px; margin-bottom: -4px">
                <button style="padding: 0" class="cl-btn-ghost"
                        (click)="clicked(1)">
                  @if (sorters()[1].dir === null) {
                    <i class="cl-faded fas fa-fw fa-sort"></i>
                  }
                  @if (sorters()[1].dir === 'up') {
                    <i class="fas fa-fw fa-sort-up"></i>
                  }
                  @if (sorters()[1].dir === 'down') {
                    <i class="fas fa-fw fa-sort-down"></i>
                  }
                </button>
              </th>
              <th class="" style="margin-top: -4px; margin-bottom: -4px">
                <button style="padding: 0" class="cl-btn-ghost"
                        (click)="clicked(2)">
                  filename
                  @if (sorters()[2].dir === null) {
                    <i class="cl-faded fas fa-fw fa-sort"></i>
                  }
                  @if (sorters()[2].dir === 'up') {
                    <i class="fas fa-fw fa-sort-up"></i>
                  }
                  @if (sorters()[2].dir === 'down') {
                    <i class="fas fa-fw fa-sort-down"></i>
                  }
                </button>
              </th>
              @if (!isSmall()) {
                <th class="" style="margin-top: -4px; margin-bottom: -4px">
                  <button style="padding: 0" class="cl-btn-ghost"
                          (click)="clicked(3)">
                    date
                    @if (sorters()[3].dir === null) {
                      <i class="cl-faded fas fa-fw fa-sort"></i>
                    }
                    @if (sorters()[3].dir === 'up') {
                      <i class="fas fa-fw fa-sort-up"></i>
                    }
                    @if (sorters()[3].dir === 'down') {
                      <i class="fas fa-fw fa-sort-down"></i>
                    }
                  </button>
                </th>
              }
              @if (!isSmall()) {
                <th class="" style="margin-top: -4px; margin-bottom: -4px">
                  <button style="padding: 0" class="cl-btn-ghost"
                          (click)="clicked(4) ">
                    size
                    @if (sorters()[4].dir === null) {
                      <i class="cl-faded fas fa-fw fa-sort"></i>
                    }
                    @if (sorters()[4].dir === 'up') {
                      <i class="fas fa-fw fa-sort-up"></i>
                    }
                    @if (sorters()[4].dir === 'down') {
                      <i class="fas fa-fw fa-sort-down"></i>
                    }
                  </button>
                </th>
              }
            </tr>
            </thead>
            @if (items.length === 0) {
              <tbody>
                @if (parent()) {
                  <tr>
                    <td></td>
                    <td></td>
                    <td><a
                      style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"
                      [routerLink]="parent() | link"
                      (click)="$event.stopPropagation()">
                      .. (up)
                    </a></td>
                    @if (!isSmall()) {
                      <td></td>
                    }
                    @if (!isSmall()) {
                      <td></td>
                    }
                  </tr>
                }
              <tr class="cl-tr-no-data">
                <td colspan="100" style="text-align: center">No files available.</td>
              </tr>
              </tbody>
            } @else {
              <tbody>
                @if (parent()) {
                  <tr>
                    <td></td>
                    <td></td>
                    <td><a
                      style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"
                      [routerLink]="parent() | link"
                      (click)="$event.stopPropagation()">
                      .. (up)
                    </a></td>
                    @if (!isSmall()) {
                      <td></td>
                    }
                    @if (!isSmall()) {
                      <td></td>
                    }
                  </tr>
                }
                @if (!parent()) {
                  <tr>
                    <td></td>
                    <td></td>
                    <td><a
                      style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"
                      [routerLink]="['/o', organization().id, 'files']"
                      (click)="$event.stopPropagation()">
                      .. (up)
                    </a></td>
                    @if (!isSmall()) {
                      <td></td>
                    }
                    @if (!isSmall()) {
                      <td></td>
                    }
                  </tr>
                }
                @for (it of items; track it) {
                  <tr>
                    <td [class.cl-faded]="it.deleted">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" [checked]="selection.isSelected(it)"
                               (change)="this.toggle(it)">
                      </div>
                    </td>
                    <td [class.cl-faded]="it.deleted">
                      <div style="margin-top: -8px; margin-bottom: -12px;">
                        <app-asset-icon [thing]="it"></app-asset-icon>
                      </div>
                    </td>
                    <td [class.cl-faded]="it.deleted">
                      <div style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                        @if (it.__typename === 'Folder') {
                          <a
                            [routerLink]=" it | link"
                            (click)="$event.stopPropagation()">
                            {{ it.name | orgResolver }}
                          </a>
                        }
                      </div>
                      @if (it.__typename === 'File') {
                        <div
                          style="display: flex; flex-direction: row">
                          <a
                            [routerLink]=" it | link">
                            {{ it.name | orgResolver }}
                          </a>
                          @if (fileQc().get(it.id)?.criticalQc) {
                            <span class="cl-color-text-brick" style="margin-left: 8px"
                                  appTooltip="Has critical QC errors — encode may fail">
                              <i class="fas fa-exclamation-circle"></i>
                            </span>
                          }
                          @if (fileQc().get(it.id)?.warningQc && !fileQc().get(it.id)?.criticalQc) {
                            <span class="cl-color-text-honey" style="margin-left: 8px"
                                  appTooltip="Has auto QC warnings">
                              <i class="fas fa-exclamation-triangle"></i>
                            </span>
                          }
                          @if (it.archive && it.archive.restore_state === RestoreState.Restored) {
                            <div class="archive-state-icon" style="width: 24px; margin-left: 8px "
                                 appTooltip="Will be moved back to archive on {{it.archive.expiration | cldate }}"
                            >
                              <i class="fas fa-box-open"></i>
                            </div>
                          }
                          @if (it.archive && it.archive.restore_state === RestoreState.Archived) {
                            <div class="archive-state-icon" style="width: 24px; margin-left: 8px "
                                 appTooltip="File has been moved to long term storage">
                              <i class="fas fa-box"></i>
                            </div>
                          }
                          @if (it.archive && it.archive.restore_state === RestoreState.Restoring) {
                            <div class="archive-state-icon" style="width: 24px; margin-left: 8px "
                                 appTooltip="Estimated time of restoration: {{it | estimatedRestorationTime}}">
                              <i class="fas fa-hourglass-half"></i>
                            </div>
                          }
                        </div>
                      }
                    </td>
                    @if (!isSmall()) {
                      <td [class.cl-faded]="it.deleted">
                        <div
                          style="text-overflow: clip; overflow: hidden; white-space: nowrap;"> {{ it.last_modified | cldate }}
                        </div>
                      </td>
                    }
                    @if (!isSmall()) {
                      <td [class.cl-faded]="it.deleted">
                        @if (it.__typename === 'File') {
                          <div style="text-overflow: clip; overflow: hidden; white-space: nowrap;"
                          >{{ it.size | fileSize }}
                          </div>
                        }
                        <div class="info-only">
                          @if (it.__typename === 'Folder') {
                            <app-folder-info [folder]="it"
                                             display="numberOfFiles"
                                             fetchPolicy="cache-only"></app-folder-info>
                          }
                        </div>
                      </td>
                    }
                  </tr>
                }
              </tbody>
              @if (selection.selected.length > 0) {
                <tfoot class="batch-actions-footer">
                <tr>
                  <td class="cl-td-links" colspan="100">
                    <small><i class="fas fa-share fa-rotate-270 cl-faded"></i></small> &nbsp;
                    <ng-container [ngTemplateOutlet]="menu"></ng-container>
                    <a class="cl-a-btn" (click)="selection.clear()">Clear Selection ({{ selection.selected.length }})</a>
                  </td>
                </tr>
                </tfoot>
              }
            }
          </table>
        </div>
      }
    </div>


  </div>
</section>
